import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../../services/auth.js";
import env from "../../../services/env.js";
import security from "../../../services/security.js";

class UbercampaignController {
  constructor($http, $state, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService, $window) {
    this.name = "ubercampaign";
    this.$http = $http;
    this.$state = $state;
    this.$cookies = $cookies;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$window = $window;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.$tracking = TrackingService;
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    this.user = {phone_type: null};
    //this.forward();
    //jobble://jobble.html

    console.log("check into the location");
    console.dir(this.$location);
    console.dir(this.$location.$$path.indexOf("/ubercampaign") > -1);

    if (this.$location.$$path.indexOf("/ubercampaign") > -1) {
      console.log("what is this");

      this.$location.path("/campaigns/direct");
    } else {
      this.discover();
    }
  }

  open() {
    var _this = this;

    _this.$window.location.href = "jobble://jobble.html";
  }

  forward() {
    var _this = this;

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      _this.$window.location.href = "https://play.google.com/store/apps/details?id=com.jobble.jobble";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      _this.$window.location.href = "https://itunes.apple.com/us/app/jobble/id961838757";
    }

    /*

		_this.$window.location.href = 'jobble://jobble.html';

		_this.$timeout(function(){

		}, 1000)

		*/
  }

  forwardAndroid() {
    var _this = this;

    _this.$window.location.href = "https://play.google.com/store/apps/details?id=com.jobble.jobble";
  }

  forwardIos() {
    var _this = this;

    _this.$window.location.href = "https://itunes.apple.com/us/app/jobble/id961838757";
  }

  discover() {
    var _this = this;

    console.log("discover");

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    console.log("user Agent");
    console.dir(userAgent);

    if (/android/i.test(userAgent)) {
      _this.$timeout(function () {
        _this.user.phone_type = "android";
      });
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      _this.$timeout(function () {
        _this.user.phone_type = "ios";
      });
    } else {
      _this.$timeout(function () {
        _this.user.phone_type = "none";
      });
    }
  }
}

UbercampaignController.$inject = [
  "$http",
  "$state",
  "$stateParams",
  "$location",
  "$timeout",
  "auth",
  "$rootScope",
  "$cookies",
  "tracking",
  "$window",
];

export default UbercampaignController;



// WEBPACK FOOTER //
// ./client/app/components/campaigns/ubercampaign/ubercampaign.controller.js